export const roles = {
  AERO_INSTRUCTOR: 'AERO_INSTRUCTOR',
  DEVELOPER: 'DEVELOPER',
  ADMIN: 'ADMIN',
  STUDENT: 'STUDENT',
  STUDENT_GUEST: 'STUDENT_GUEST',
  SUPPORT: 'SUPPORT',
};
